import iStoreDto from "./IStoreDto";
import IStoresDto from "./IStoresDto";

export class StoresDto implements IStoresDto {
    public dealerStores: iStoreDto[] = [];
}
